<template>
    <div class="flex align-items-center h-20rem w-full text-center my-3">
        <ProgressSpinner />
    </div>
</template>

<script>
export default {
    name: 'loafing',
}
</script>